import Integration from '@/orm/models/Integration/Integration';
import { computed } from '@vue/composition-api';
import { response } from '@/orm/functions';

let isFetchingAll = false;
let fetchAllPromise = null;

export default function useIntegrations() {
  const integrations = computed(() => Integration.all());

  async function fetchAll() {
    if (isFetchingAll && fetchAllPromise) {
      return fetchAllPromise;
    }

    const existingIntegrations = Integration.all();
    if (existingIntegrations?.length > 0) {
      return Promise.resolve();
    }

    isFetchingAll = true;
    fetchAllPromise = Integration.api().fetchAll()
      .finally(() => {
        isFetchingAll = false;
        fetchAllPromise = null;
      });

    return fetchAllPromise;
  }

  async function getRegistrationData() {
    return response(await Integration.api().getRegistrationData());
  }

  async function registerCompany(payload) {
    await Integration.api().registerCompany(payload);
  }

  return {
    integrations,
    hasActiveIntegration: computed(() => integrations.value?.some((i) => i.connected)),
    hasIntegrations: computed(() => integrations.value?.length > 0),
    fetchAll,
    getRegistrationData,
    registerCompany,
  };
}
